import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useUserOrganizationMembership } from '@modules-deprecated/app/organization/hooks/useUserOrganizationMembership'
import { useUmbrella, useUmbrellaStatus } from '@modules-deprecated/app/umbrellas'
import { useIsDmsEnabled } from '@views/documents/hooks/useIsDmsEnabled'

import { useOrganizationUiSetup } from './useOrganizationUiSetup'

export const useAdvisorAccess = () => {
  const isDmsEnabled = useIsDmsEnabled()
  const { isOrganizationMode, isLoading: isUmbrellaStatusLoading } = useUmbrellaStatus()
  const { isLoading: isUmbrellaLoading } = useUmbrella()
  const { isViaUmbrella } = useUserOrganizationMembership()
  const { isUiSetupShineInvoicingAccounting } = useOrganizationUiSetup()
  const { organization } = useUserOrganization()

  const umbrellaUrlPath = organization?.ownerUmbrellaId ? `/umbrellas/${organization.ownerUmbrellaId}` : undefined

  const isCpaInOrganizationView =
    isDmsEnabled && isViaUmbrella && isOrganizationMode && !isUmbrellaStatusLoading && !isUmbrellaLoading

  const shouldShowToggle = isCpaInOrganizationView
  const shouldShowBackButton = isCpaInOrganizationView && !isUiSetupShineInvoicingAccounting && !!umbrellaUrlPath

  return { shouldShowBackButton, shouldShowToggle, umbrellaUrlPath }
}
